module.exports = __webpack_public_path__ + "fonts/fd5970128586cba8e7ed994f134ec176-Roboto-Italic.woff";